"use strict";
exports.__esModule = true;
exports.SvgFileAttachmentsBox = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgFileAttachmentsBox = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 20 20" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("rect", { width: 20, height: 20, fill: "#0061D5", rx: 1.25 }),
        react_1["default"].createElement("path", { fill: "#FFF", d: "M6.25 2.5c.69 0 1.25.56 1.25 1.24v3.457A5.624 5.624 0 1110.625 17.5a5.625 5.625 0 01-5.619-5.357H5V3.74c0-.643.488-1.171 1.121-1.235L6.25 2.5zm4.375 6.25A3.125 3.125 0 007.5 11.84v.07l.005.142a3.125 3.125 0 103.12-3.302z" })))); };
//# sourceMappingURL=FileAttachmentsBox.js.map